var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#09090B",
    strokeLinecap: "square",
    strokeWidth: 1.5,
    d: "M3.87 3.938h.136m.272 0a.34.34 0 1 1-.68 0 .34.34 0 0 1 .68 0ZM.875.874V7L7 13.125 13.125 7 7 .875z"
  })));
};
export default SvgTag;